// @flow
import React from 'react';
import {computed} from 'mobx';
import {observer} from 'mobx-react';
import NumberComponent from 'sulu-admin-bundle/components/Number';
import type {FieldTypeProps} from 'sulu-admin-bundle/types';

@observer
class HelpLink extends React.Component<FieldTypeProps<?number>> {
    @computed get min(): ?number {
        const {schemaOptions} = this.props;
        return schemaOptions.min ? parseFloat(schemaOptions.min.value) : undefined;
    }

    @computed get max(): ?number {
        const {schemaOptions} = this.props;
        return schemaOptions.max ? parseFloat(schemaOptions.max.value) : undefined;
    }

    @computed get step(): ?number {
        const {schemaOptions} = this.props;
        return schemaOptions.step ? parseFloat(schemaOptions.step.value) : undefined;
    }

    @computed get message(): ?string {
        const {schemaOptions} = this.props;
        return schemaOptions.message ? schemaOptions.message.value : undefined;
    }

    @computed get link(): ?string {
        const {schemaOptions} = this.props;
        return schemaOptions.link ? schemaOptions.link.value : undefined;
    }

    @computed get linkText(): ?string {
        const {schemaOptions} = this.props;
        return schemaOptions.linkText ? schemaOptions.linkText.value : undefined;
    }

    handleBlur = () => {
        this.props.onFinish();
    };

    render() {
        const {dataPath, disabled, error, onChange, value} = this.props;

        return (
            <div>
            {/* Le champ de saisie réel */}
            <NumberComponent
                disabled={!!disabled}
                id={dataPath}
                max={this.max}
                min={this.min}
                onBlur={this.handleBlur}
                onChange={onChange}
                step={this.step}
                valid={!error}
                value={value}
            />
            {/* Le bloc d'aide stylisé en dessous */}
            <div style={{ 
                padding: '10px 15px', 
                fontSize: '13px', 
                backgroundColor: '#f8f9fa', 
                borderRadius: '4px',
                borderLeft: '4px solid #2f5ed7',
                marginTop: '8px',
                color: '#555'
            }}>
                {this.message && <span style={{ marginRight: '5px' }}>{this.message}</span>}
                {this.link && (
                    <a 
                        href={this.link} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        style={{ 
                            color: '#2f5ed7', 
                            textDecoration: 'underline',
                            fontWeight: '600'
                        }}
                    >
                        {this.linkText || this.link}
                    </a>
                )}
            </div>
        </div>
        );
    }
}

export default HelpLink;
